










import { Component, Prop } from 'vue-property-decorator';
import { TextBlockViewObject } from '@/types/apiServerContract';
import BaseBlock from './BaseBlock.vue';

@Component({
    components: { BaseBlock }
})
export default class TextBlock extends BaseBlock {
	@Prop({
	    required: true,
	    type: Object
	})
	content!: TextBlockViewObject;
}
